import { APIScope, SequenceInterface } from "@swivl-mono/types";
import { Button, ButtonVariant, LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";
import { Outlet } from "react-router-dom";

import { ShowIf } from "../../../Components/ShowIf/ShowIf";
import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import ModalModel from "../../../Models/Modal/Modal.Model";
import SequencesModel from "../../../Models/Sequences/SequencesModel";
import { SequenceListItem } from "./Components/Sequence.ListItem";
import { SequenceCreateModal } from "./Modal/SequenceCreate.Modal";

function getSequenceDays(sequence: SequenceInterface): number {
  const { conditions } = sequence;
  if ("daysAgo" in conditions) return conditions.daysAgo;
  if ("daysSince" in conditions) return conditions.daysSince;
  if ("daysPastDue" in conditions) return conditions.daysPastDue;
  return 0;
}

export function SequenceSettingsView() {
  const { sequences } = SequencesModel.useState();
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  // const sequenceArray = Object.values(sequences || [])

  const sequencesArrayGroupedByType: { type: string; sequences: SequenceInterface[] }[] | undefined = useMemo(() => {
    if (!sequences) {
      return undefined;
    }
    let sequencesByType = {};
    Object.values(sequences || []).forEach((sequence) => {
      if (!sequencesByType[sequence.type]) {
        sequencesByType[sequence.type] = [];
      }
      sequencesByType[sequence.type].push(sequence);
    });
    return Object.entries(sequencesByType)
      .map(([type, sequences]) => ({
        type: type.replace("_", " "),
        sequences: (sequences as SequenceInterface[]).slice().sort((a, b) => getSequenceDays(a) - getSequenceDays(b))
      }))
      .sort((a, b) => a.type.localeCompare(b.type));
  }, [sequences]);
  return (
    <LayoutWithSidebar
      sidebar={
        <div className="mt-5 flex flex-col">
          {sequencesArrayGroupedByType ? (
            <>
              {sequencesArrayGroupedByType.map((typeGroup) => (
                <div key={typeGroup.type} className="mb-3">
                  <label className="ml-2">{typeGroup.type}</label>
                  {typeGroup.sequences.map((sequence) => (
                    <SidebarLink to={"/settings/sequences/" + sequence.id} key={sequence.id} height={38}>
                      {sequence.name}
                    </SidebarLink>
                  ))}
                </div>
              ))}

              <ShowIf scope={APIScope.SEQUENCES_EDIT}>
                <Button
                  className="m-2"
                  variant={ButtonVariant.DASHED}
                  onClick={() => {
                    ModalModel.showModalWithContent(<h2>Add Sequence</h2>, <SequenceCreateModal />);
                  }}
                >
                  + Add Sequence{" "}
                </Button>
              </ShowIf>
            </>
          ) : (
            <div className="align-center flex justify-center">
              <Spinner />
            </div>
          )}
        </div>
      }
      content={<Outlet />}
    />

    // <div className="m-5">
    //     <h1>Sequence Settings {sequenceArray?.length}</h1>
    //     {sequenceArray?.map((sequence, index) => <SequenceListItem key={sequence.id} sequence={sequence} />)}
    // </div>
  );
}
